module.exports = __webpack_public_path__ + "static/media/lang11.1a42cc83.mp3";